const initState = {
  isShowExceptionModal: false,
  apiExceptionMessage: '',
  addToCartResponse: [],
  product: [],
  simpleProductList: [],
  productSimpleInfo:[], // 商品簡易資訊
  pointOfServices: [], // 店取商店資訊
  couponList: [],
  deliveryModeCode: '', // 用來判斷到底是 normal 還是 pickup，最後送 request 時要檢查
  // 商品頁加入購物車 request
  requestProductCode: '', // 品號
  requestChangePoint: false, // 是否使用愛家卡點數 boolean
  requestQty: 1, // 主商品數量
  requestCatePath: '', // 分類路徑、通路
  requestDeliveryMode: '', // 宅配方式（宅配：空值、店取：店名）
  requestDeliveryCost: 'nonInstallation', // 其他服務（不安裝：nonInstallation、安裝：needInstallation）
  requestAdditionalPurchases: [], // 加購商品 arrayObject { sku: xxxx, qty: xx }
  requestBundleProducts: [], // 組合商品 arrayObject { sku: xxxx, qty: xx }
  webChatUrl:'', // 一對一文字客服url
};

export function productState(state = initState, action) {
  switch (action.type) {
    case 'GET_PRODUCT_DATA': {
      return {
        ...state,
        product: action.payload,
      };
    }
    case 'UPDATE_SIMPLEPRODUCTLIST': {
      return {
        ...state,
        simpleProductList: action.payload,
      };
    }
    case 'GET_PRODUCT_SIMPLE_INFO': {
      return {
        ...state,
        productSimpleInfo: action.payload,
      };
    }
    case 'GET_POINT_OF_SERVICES': {
      return {
        ...state,
        pointOfServices: action.payload,
      };
    }
    // 以下為更新 request 參數 action
    case 'UPDATE_REQUEST_PRODUCT_CODE': {
      return {
        ...state,
        requestProductCode: action.payload,
      };
    }
    case 'UPDATE_REQUEST_CHANGE_POINT': {
      return {
        ...state,
        requestChangePoint: action.payload,
      };
    }
    case 'UPDATE_REQUEST_QTY': {
      return {
        ...state,
        requestQty: action.payload,
      };
    }
    case 'UPDATE_REQUEST_CATE_PATH': {
      return {
        ...state,
        requestCatePath: action.payload,
      };
    }
    case 'UPDATE_REQUEST_DELIVERY_MODE': {
      return {
        ...state,
        requestDeliveryMode: action.payload,
      };
    }
    case 'UPDATE_REQUEST_DELIVERY_COST': {
      return {
        ...state,
        requestDeliveryCost: action.payload,
      };
    }
    case 'UPDATE_REQUEST_ADDITIONAL_PURCHASES': {
      const finalAdditionalPurchases = [];
      const newAdditionalPurchases = action.payload;
      newAdditionalPurchases.forEach((item) => {
        if (item.checked) {
          finalAdditionalPurchases.push({
            qty: item.qty,
            sku: item.sku,
          });
        }
      });
      return {
        ...state,
        requestAdditionalPurchases: finalAdditionalPurchases,
      };
    }
    case 'UPDATE_REQUEST_BUNDLE_PRODUCTS': {
      const finalBundleProducts = [];
      const newBundleProducts = action.payload;
      newBundleProducts.forEach((item) => {
        //if (item.checked) {
          finalBundleProducts.push({
            qty: item.qty,
            sku: item.sku,
            checked: item.checked,
            stockLevel: item.stockLevel,
            spec: item.spec,
            name: item.name,
          });
        //}
      });
      return {
        ...state,
        requestBundleProducts: finalBundleProducts,
      };
    }
    case 'UPDATE_DELIVERY_MODE_CODE': {
      return {
        ...state,
        deliveryModeCode: action.payload,
      };
    }
    case 'GET_COUPON_LIST_FOR_PRODUCT': {
      return {
        ...state,
        couponList: action.payload,
      };
    }
    case 'UPDATE_ADD_TO_CART_RESPONSE': {
      return {
        ...state,
        addToCartResponse: action.payload,
      };
    }
    case 'SHOW_EXCEPTION_MODAL': {
      return {
        ...state,
        isShowExceptionModal: true,
      };
    }
    case 'CLOSE_EXCEPTION_MODAL': {
      return {
        ...state,
        isShowExceptionModal: false,
      };
    }
    case 'UPDATE_API_RESPONSE_MESSAGE': {
      return {
        ...state,
        apiExceptionMessage: action.payload,
      };
    }
    case 'POST_WEB_CHAT': {
      return {
        ...state,
        webChatUrl: action.payload,
      };
    }
    default:
      return state;
  }
}

export default productState;
